"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeApartmentLabel = void 0;
const makeApartmentLabel = (identifier, buildingName) => {
    return buildingName ? buildingName + ' \u2013 ' + identifier : identifier;
};
exports.makeApartmentLabel = makeApartmentLabel;
